(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]',
            next: '[data-next]',
            prev: '[data-prev]'
        }

        subscriptions = {
            'variant:change': '_onVariantChange'
        }

        render() {
            this._initSwiper();
            this.subscribe('variant:change');
        }

        _initSwiper() {
            var allowLoop = this.getAttribute("data-loop") || false;
            var allowTouch = this.getAttribute("data-touch") || false;
            var allowZoom = this.hasAttribute('data-zoom') || false;
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                loop: allowLoop,
                zoom: allowZoom,
                navigation: {
                    nextEl: this.$next,
                    prevEl: this.$prev,
                },
               
                breakpoints: {
                    992: {
                        allowTouchMove: allowTouch
                    }
                },
                   on: {
            slideChange: function () {
              if (typeof productOptions != "undefined") {
                if (productOptions.length > 0) {
                 
                  var current_slide = this.slides[this.activeIndex];
                  if (current_slide) {  
                  var current_slide_img = current_slide.querySelector("img");
 
                  if (current_slide_img) {
                    var arrImage = current_slide_img
                      .getAttribute("src")
                      .split("?")[0]
                      .split(".");
                    var strExtention = arrImage.pop();
                    var strRemaining = arrImage
                      .pop();
                      //.replace(/_[a-zA-Z0-9@]+$/, "");
                    var strNewImage =
                      arrImage.join(".") +
                      "." +
                      strRemaining +
                      "." +
                      strExtention;
                    if (typeof variantImages !== "undefined") {
                       
                      if (typeof variantImages[strNewImage] !== "undefined") {
                        productOptions.forEach(function (value, j) {
                       
                          var optionValue =
                            variantImages[strNewImage]["option-" + j];
                          if (optionValue !== null) {
                            var options_blocks = document.querySelectorAll(
                              "product-options-dropdown select option"
                            );
                            // debugger;
                              for (var k = 0; k < options_blocks.length; k++) {
        
                              if (optionValue === options_blocks[k].value) {
                                 
                              if(options_blocks[k].closest("select").value != optionValue){
                              options_blocks[k].closest("select").value = optionValue;  
                              var needed_options_block = options_blocks[k];   
                               setTimeout(() => { 
                                needed_options_block.closest("select").dispatchEvent(                                 
                                    new Event("change", { bubbles: true })                                                                
                                );
                               },100) ;
                              } 
                              }
                            }
                          }
                        });
                      }
                    }
                  }
                }
                }
              }
            }
          }
            });
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }else{
              if(document.querySelector(".product-page-section")){
                var ID = this.id;
                var mainSlider = document.querySelector(".product-page-section").querySelector("#"+ID);
                if(mainSlider){
                  var activeSlide = mainSlider.querySelector(".swiper-slide-active");
                  if(activeSlide){
                    var activeIndex = [...activeSlide.parentNode.children].indexOf(activeSlide);
                    if(activeIndex){
                      
                       this.swiper.slideTo(activeIndex+1)
                    }
                  }
                }
              }
            }
        }

        _onVariantChange({ variantImagePosition}) {
            if(variantImagePosition) {
                this.swiper.slideTo(variantImagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();